<div class="cb-toggle" [class.cb-disabled]="disabled()" (click)="toggle()" [class.cb-required]="required()"
  [ngClass]="['cb-size-' + size()]">
  <div class="cb-toggle-btn" [class.cb-selected]="value" [ngClass]="['cb-size-' + size()]"></div>
  <div class="cb-toggle-text">
    @if (label()) {
    <p>{{ label() }}</p>
    }
    @if (hint()) {
    <span>{{ hint() }}</span>
    }
  </div>
</div>